import styled from "styled-components";
import Select from "react-select";
import { Empresa } from "smart-imob-types";

interface SelectMultipleProps {
  empresa: Empresa;
}

const SelectMultiple = styled(Select)<SelectMultipleProps>`
  .home__control {
    margin-bottom: 15px;
  }
  .home__value-container {
    min-height: 48px;
  }
  .home__indicator {
    padding: 0;
  }
  .home__indicator-separator {
    background-color: none;
    width: 0;
  }
  .css-yk16xz-control:hover {
    border-color: ${props => props.empresa.palleta.cor_primaria || "#b3b3b3"};
  }
  .css-1pahdxg-control,
  .css-1pahdxg-control:hover {
    box-shadow: none;
    border-color: ${props => props.empresa.palleta.cor_primaria || "#2684ff"};
  }
`;

export default SelectMultiple;
